/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Filters from '../../../../components/Filters'
import Button from '../../../../components/Button'
import { ControlTable } from '../../../../components/Table';
import useForm from '../../../../hooks/useForm';
import { getBankTransRecordListEach } from '../../../../apis/finances/bank';
import { getParams } from '../../../../utils/params';
import { get } from 'lodash';
import systemAlert from '../../../../utils/systemAlert';
import { getDay } from '../../../../utils/date';
import { createCardRecordsUseItems } from '../../../../apis/finances/cards';
import { isEmpty } from '../../../../utils/lodashExtend';

const BankTransListModal = ({ open, setOpen, cardData, detailSubmit, type }) => {
  const [fields] = useState([
    {
      title: "거래일자", key: "tradeTime", type: 'date'
    },
    {
      title: "입금액", key: "inAmt", type: 'comma', className: 'color-red-100'
    },
    {
      title: "출금액", key: "outAmt", type: 'comma', className: 'color-purple-100'
    },
    {
      title: "적요", key: "traderName",
    },
    {
      title: "거래처",
      key: "clients",
      onValue: (value, field, data) => {
        return (
          !isEmpty(value) &&
          value.map((client, idx) => (
            <p className="pt-8 pb-8" key={idx}>
              <span className="vertical-middle">{client.name}</span>
            </p>
          ))
        )
      }
    },
  ]);
  const [filters] = useState([
    {
      title: '조회기간',
      type: 'customdatepicker',
      key: 'range.tradeTime'
    },
  ]);

  const cancel = () => {
    setOpen(false)
    reset()
  }

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reset
  } = useForm(
    {
      order: [
        {
          tradeTime: "desc"
        },
      ],
      transType: type === 'sales' ? 'inAmt' : 'outAmt',
      range: {
        tradeTime: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    submit(form);
    setSubmit(submit)
  }, []);

  const submit = (params) => {
    getBankTransRecordListEach(getParams(params))
      .then((res) => {
        setTotal(get(res, 'data.totalCount'))
        setList(get(res, 'data.transList'))
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false)
        setSelectedList([]);
      });
  };

  const handleApply = () => {
    const body = {
      list: selectedList.map((d) => ({
        cardUseType: type,
        cardUseIdx: cardData.idx,
        itemType: "bank_trans",
        itemIdx: d.idx
      }))
    }

    systemAlert('선택된 은행입출금 내역을 연관데이터로 등록하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            createCardRecordsUseItems(body).then(() => { detailSubmit(); cancel(); })
          }
        }
      ]
    })
  }

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange} />
      <ControlTable
        fields={fields}
        list={list}
        selectedList={selectedList}
        setSelected={setSelectedList}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        submit={handleSubmit}
      />
      <div className="submit-button-wrap float-right margin-top-32">
        <Button
          className="button"
          size="lg"
          label="취소"
          color="text"
          action={cancel}
        />
        <Button
          className="button"
          size="lg"
          label="적용하기"
          action={handleApply}
        />
      </div>
    </>
  )
}

export default BankTransListModal;